import * as React from 'react';
import { SelectInput, useTranslate } from 'react-admin';

const toChoices = (items, translate) =>
    items.map(item => ({
        id: item,
        name: translate(`resources.reviews.status.${item}`),
    }));
const AvisStatutInput = props => {
    const translate = useTranslate();
    const statuts = [
        'accepted',
        'rejected',
        'pending',
    ];
    return (
        <SelectInput
            choices={toChoices(statuts, translate)}
            {...props}
            emptyText="Tout"
        />
    );
};

export default AvisStatutInput;
